import { UUID } from "../generic/uuid";
import { createWineDtoFromAnalyticWineModel, WineModel } from "./wine";
import { VintageDto } from "@vini-wine/core-dtos";

export interface VintageModel extends UUID {
  // transform
  year: number;

  // available includes
  wine?: WineModel;
}

export const createVintageDtoFromAnalyticVintageModel = (
  vintage: VintageModel,
): VintageDto => {
  return {
    uuid: vintage.uuid,
    year: vintage.year,
    wine: vintage.wine
      ? createWineDtoFromAnalyticWineModel(vintage.wine)
      : undefined,
  };
};
